var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.725 18.1794L14.7382 21.311C15.1861 22.0079 16.1142 22.2096 16.8111 21.7616C17.5079 21.3137 17.7097 20.3856 17.2617 19.6887L14.0723 14.7275C14.0034 14.9657 13.93 15.2047 13.8519 15.444C13.563 16.3282 13.1946 17.2595 12.725 18.1794Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9345 13.14C13.865 13.8933 15.0851 14.5673 16.6361 14.9551C17.4398 15.156 18.2542 14.6674 18.4551 13.8637C18.6561 13.06 18.1674 12.2456 17.3637 12.0447C15.3521 11.5417 14.2235 10.3895 13.7082 9.5839C13.5002 9.25874 13.1954 8.84252 12.7737 8.50533C12.3328 8.15275 11.7048 7.84345 10.9231 7.89012C8.90701 8.01048 6.44107 9.43303 5.57689 12.0255C5.31492 12.8115 5.73966 13.6609 6.52558 13.9229C7.31149 14.1849 8.16097 13.7601 8.42294 12.9742C8.73391 12.0413 9.50809 11.3857 10.2787 11.0786C10.1332 12.0066 9.90697 13.0279 9.5742 14.0466C8.87232 16.1951 7.76172 18.1357 6.13985 19.271C5.46118 19.7461 5.29613 20.6814 5.7712 21.3601C6.06262 21.7764 6.52721 21.9994 6.99951 22C7.29716 22.0004 7.59788 21.9124 7.86024 21.7287C10.2384 20.064 11.6278 17.4213 12.4259 14.9782C12.6277 14.3605 12.7958 13.7431 12.9345 13.14Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4999 4.5C14.4999 5.88071 13.3806 7 11.9999 7C10.6192 7 9.49992 5.88071 9.49992 4.5C9.49992 3.11929 10.6192 2 11.9999 2C13.3806 2 14.4999 3.11929 14.4999 4.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.6c3fae6685435b1ca9feb6f84d16405f.svg";
export { ForwardRef as ReactComponent };